export default __webpack_public_path__ + "static/media/330_dummy2016-apotheke01-mobile-de.4fc4f10c.png";